import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from "reactstrap";
import classnames from "classnames";
import * as Yup from "yup";
import { useFormik } from "formik";
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
// Dropzone importu
import Dropzone from 'react-dropzone-uploader'; 
import 'react-dropzone-uploader/dist/styles.css'; // Stil dosyasını eklemeyi unutmayın

import {
  getSliders as onGetSliders,
  addSlider as onAddSlider,
  updateSlider as onUpdateSlider,
  deleteSlider as onDeleteSlider,
} from "store/contacts/actions";
import { useSelector, useDispatch } from "react-redux";

const ContactsList = props => {
  document.title = "Slider Yönetimi | Tazelya ADMIN PANELI";

  const dispatch = useDispatch();
  const { users } = useSelector(state => ({
    users: state.contacts.sliders,
  }));

  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [contactEdit, setEditContact] = useState(null);
  const [activeTab, setActiveTab] = useState("1");
  const [deleteModal, setDeleteModal] = useState(false);
  
  // Resim State'leri (Dosya adlarını tutar)
  const [getFileName, setFileName] = useState(null);      // TR
  const [getFileNameEn, setFileNameEn] = useState(null);  // EN
  const [getFileNameAr, setFileNameAr] = useState(null);  // AR

  // --- AYARLAR ---
  // Resimlerin görüntüleneceği sunucu adresi
  const IMAGE_BASE_URL = 'https://bittigittipreview.stechomeyazilim.info/';
  
  // Resimlerin yükleneceği API adresi (Backend portu 9024 ile uyumlu)
  const UPLOAD_URL = 'https://bittigitti.online:9024/uploadfile';

  // --- API VERİ ÇEKME ---
  useEffect(() => {
    dispatch(onGetSliders());
  }, [dispatch]);

  // --- MODAL AÇ/KAPA ---
  const toggle = () => {
    setModal(!modal);
    if (!modal) {
      setEditContact(null);
      setFileName(null);
      setFileNameEn(null);
      setFileNameAr(null);
      setIsEdit(false);
      setActiveTab("1");
    }
  };

  // --- FORMIK DOĞRULAMA ---
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      sort: (contactEdit && contactEdit.Sort) || ""
    },
    validationSchema: Yup.object({
      sort: Yup.number().required("Sıralama zorunludur"),
    }),
    onSubmit: values => {
      const payload = {
        Sort: values.sort,
        Slider_Url: getFileName,     // TR Resim Adı
        Slider_Url_En: getFileNameEn, // EN Resim Adı
        Slider_Url_Ar: getFileNameAr, // AR Resim Adı
      };

      if (isEdit) {
        dispatch(onUpdateSlider({ ...payload, ID: contactEdit.ID }));
      } else {
        dispatch(onAddSlider(payload));
      }
      toggle();
    },
  });

  // --- DÜZENLE BUTONU ---
  const handleEditClick = (user) => {
    setEditContact(user);
    // Mevcut resimleri state'e aktar
    setFileName(user.Slider_Url || null);
    setFileNameEn(user.Slider_Url_En || null);
    setFileNameAr(user.Slider_Url_Ar || null);
    setIsEdit(true);
    setModal(true);
  };

  const handleChangeStatusTR = ({ xhr, meta }, status) => {
    console.log("şmsşdf",xhr)
    if (status === 'done' && xhr && xhr.response) {
      const result = JSON.parse(xhr.response);
      setFileName(result.file.filename);
    }
  };

  // 2. İngilizce Resim Yükleme Sonucu
  const handleChangeStatusEN = ({ xhr, meta }, status) => {
    if (status === 'done' && xhr && xhr.response) {
      const result = JSON.parse(xhr.response);
      setFileNameEn(result.file.filename);
    }
  };

  // 3. Arapça Resim Yükleme Sonucu
  const handleChangeStatusAR = ({ xhr, meta }, status) => {
    if (status === 'done' && xhr && xhr.response) {
      const result = JSON.parse(xhr.response);
      setFileNameAr(result.file.filename);
    }
  };

  // --- TABLO KOLONLARI ---
  const columns = useMemo(() => [
    {
      Header: "Önizleme",
      accessor: (row) => (
        <div className="avatar-xs">
          {row.Slider_Url ? (
            <img 
              className="rounded avatar-xs" 
              src={IMAGE_BASE_URL + row.Slider_Url} 
              alt="slider-img" 
            />
          ) : (
            <span className="avatar-title rounded bg-soft-primary text-primary">Img</span>
          )}
        </div>
      ),
    },
    {
      Header: "Sıralama",
      accessor: "Sort",
      Cell: cellProps => <span className="fw-bold">{cellProps.value}</span>,
    },
    {
      Header: "İşlemler",
      Cell: cellProps => (
        <div className="d-flex gap-3">
          <Link to="#" className="text-success" onClick={() => handleEditClick(cellProps.row.original)}>
            <i className="mdi mdi-pencil font-size-18" />
          </Link>
          <Link to="#" className="text-danger" onClick={() => { setEditContact(cellProps.row.original); setDeleteModal(true); }}>
            <i className="mdi mdi-delete font-size-18" />
          </Link>
        </div>
      ),
    },
  ], []);


    const getUploadParams = ({ file }) => {
    const body = new FormData();
    body.append('dataFile', file);
    return { url: UPLOAD_URL, body }
  }


  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={() => { dispatch(onDeleteSlider(contactEdit.ID)); setDeleteModal(false); }}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Slider Listesi" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={users || []}
                    isGlobalFilter={true}
                    isAddSlider={true}
                    handleOrderClicks={() => { setIsEdit(false); setEditContact(null); setModal(true); }}
                    customPageSize={10}
                  />

                  <Modal isOpen={modal} toggle={toggle} size="lg" centered>
                    <ModalHeader toggle={toggle}>{isEdit ? "Slider Düzenle" : "Yeni Slider Ekle"}</ModalHeader>
                    <ModalBody>
                      <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }}>
                        <Row>
                          <Col md={12}>
                            <div className="mb-4">
                              <Label>Sıralama Değeri</Label>
                              <Input
                                name="sort"
                                type="number"
                                placeholder="Örn: 1"
                                onChange={validation.handleChange}
                                value={validation.values.sort}
                                invalid={validation.touched.sort && !!validation.errors.sort}
                              />
                              <FormFeedback>{validation.errors.sort}</FormFeedback>
                            </div>

                            {/* DİL SEKMELERİ */}
                            <Nav tabs className="nav-tabs-custom nav-justified mb-3">
                              <NavItem><NavLink className={classnames({ active: activeTab === "1" })} onClick={() => setActiveTab("1")}>Türkçe Görsel</NavLink></NavItem>
                              <NavItem><NavLink className={classnames({ active: activeTab === "2" })} onClick={() => setActiveTab("2")}>English Image</NavLink></NavItem>
                              <NavItem><NavLink className={classnames({ active: activeTab === "3" })} onClick={() => setActiveTab("3")}>العربية</NavLink></NavItem>
                            </Nav>

                            <TabContent activeTab={activeTab}>
                              
                              {/* --- TÜRKÇE TABI --- */}
                              <TabPane tabId="1">
                                <Label>Görsel (TR)</Label>
                                <Dropzone 
                                   getUploadParams={getUploadParams}
                                  onChangeStatus={handleChangeStatusTR} 
                                  maxFiles={1} 
                                  accept="image/*" 
                                  inputContent="Görseli Buraya Sürükleyin (TR)"
                                  styles={{ dropzone: { minHeight: 150, maxHeight: 150 } }}
                                />
                                {getFileName && (
                                  <div className="mt-2 text-center">
                                    <Label>Yüklenen Görsel:</Label><br/>
                                    <img src={IMAGE_BASE_URL + getFileName} className="img-thumbnail" style={{ height: '150px' }} alt="TR Preview" />
                                  </div>
                                )}
                              </TabPane>

                              {/* --- İNGİLİZCE TABI --- */}
                              <TabPane tabId="2">
                                <Label>Image (EN)</Label>
                                <Dropzone 
                                  getUploadParams={getUploadParams}
                                  onChangeStatus={handleChangeStatusEN} 
                                  maxFiles={1} 
                                  accept="image/*" 
                                  inputContent="Drag image here (EN)" 
                                  styles={{ dropzone: { minHeight: 150, maxHeight: 150 } }}
                                />
                                {getFileNameEn && (
                                  <div className="mt-2 text-center">
                                    <Label>Uploaded Image:</Label><br/>
                                    <img src={IMAGE_BASE_URL + getFileNameEn} className="img-thumbnail" style={{ height: '150px' }} alt="EN Preview" />
                                  </div>
                                )}
                              </TabPane>

                              {/* --- ARAPÇA TABI --- */}
                              <TabPane tabId="3">
                                <Label className="d-block text-end">Görsel (AR)</Label>
                                <Dropzone 
                                   getUploadParams={getUploadParams}
                                  onChangeStatus={handleChangeStatusAR} 
                                  maxFiles={1} 
                                  accept="image/*" 
                                  inputContent="Drag image here (AR)" 
                                  styles={{ dropzone: { minHeight: 150, maxHeight: 150 } }}
                                />
                                {getFileNameAr && (
                                  <div className="mt-2 text-center">
                                    <Label>Uploaded Image:</Label><br/>
                                    <img src={IMAGE_BASE_URL + getFileNameAr} className="img-thumbnail" style={{ height: '150px' }} alt="AR Preview" />
                                  </div>
                                )}
                              </TabPane>

                            </TabContent>
                          </Col>
                        </Row>
                        <div className="text-end mt-4">
                          <button type="submit" className="btn btn-success w-md">{isEdit ? "Güncelle" : "Kaydet"}</button>
                        </div>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);